module.exports = __webpack_public_path__ + "static/media/ReportsIcon.747db263.png";